export const ModalPages = Object.freeze({
  ADD: 'ADD',
  EDIT: 'EDIT',
  MANAGE: 'MANAGE'
});
export const FONT_FILE_TYPES = ['font/ttf', 'font/otf', 'application/font-woff',
//for ATs
'application/vnd.oasis.opendocument.formula-template'];